const truncate = (str: string, num: number, barcode?: boolean) => {
    if (barcode) {
        return str.length > num ? str.substring(0, num) : str;
    }
    return str.length > num ? str.substring(0, num) + "..." : str;
};

export default truncate;
